<template>
  <app-content>
    <app-delete-label-dialog
            v-if="deletedItem"
            :item="deletedItem"
            @refreshDeletedItem="refreshDeletedItem"
    />
    <app-content-body>

      <div class="inner">
        <p class="buttons">
          <a
            class="btn btn_action btn_add"
            title="Přidat štítek"
            @click.prevent="createItem"
          >Přidat štítek</a>
        </p>
        <h1 v-translate>Štítky</h1>
      </div>

      <app-table
              clickable
              deletable
              noPagination
              :data="items"
              :highlight-rows-on-hover="true"
              :order="params.order"
              :page-size="params.limit"
              @sort="sortItems"
              @rowClick="goToDetail"
              @deleteRow="deleteItem"
              :loading="pending"
      >
        <template slot="header">
          <app-table-header-item class="field_left">
            <app-input
                :label="translations.search"
                name="search"
                type="search"
                v-model="params.search"
                @input="fetchItems(true)"
            />
          </app-table-header-item>
          <app-table-header-item class="field_right">
            <app-table-header-select :label="translations.type">
              <app-select
                  :options="typeSelect"
                  v-model.trim="params.type"
                  @change="fetchItems(true)"
              />
            </app-table-header-select>
          </app-table-header-item>
          <app-table-header-item class="field_left">
            <app-input
                :label="translations.weight"
                name="weightSearch"
                type="numberSearch"
                v-model.trim="params.weight"
                @input="fetchItems(true)"
            />
          </app-table-header-item>
          <app-table-header-item class="field_right">
            <app-table-header-select :label="translations.showInDashboard">
              <app-select
                  :options="showInDashboardSelect"
                  v-model.trim="params.showInDashboard"
                  @change="fetchItems(true)"
              />
            </app-table-header-select>
          </app-table-header-item>
        </template>

        <app-table-column first sortable attribute="labelNames" :label="translations.name">
          <template slot-scope="row">
            <strong>
              <div v-html="row.labelName" />
            </strong>
          </template>
        </app-table-column>
        <app-table-column sortable attribute="type" :label="translations.type">
          <template slot-scope="row">
            {{ enumsMap.get(row.type) }}
          </template>
        </app-table-column>
        <app-table-column sortable attribute="weight" :label="translations.weight">
          <template slot-scope="row">
            <div v-html="row.weight" />
          </template>
        </app-table-column>
        <app-table-column sortable attribute="numberOfShows" :label="translations.numberOfShows" />
        <app-table-column sortable attribute="numberOfBroadcasts" :label="translations.numberOfBroadcasts" />
        <app-table-column sortable attribute="numberOfSynonyms" :label="translations.numberOfSynonyms" />
        <app-table-column :image-icon="true" :label="translations.logo" :class="'image--icon'">
          <template slot-scope="row">
            <img v-if="getIconUrl(row)" :src="getIconUrl(row)" :alt="translations.logo">
          </template>
        </app-table-column>
        <app-table-column sortable attribute="showInDashboard" :label="translations.showInDashboard">
          <template slot-scope="row">
            <app-graphic-image
              :value="row.showInDashboard"
            />
          </template>
        </app-table-column>
        <app-table-column sortable attribute="created" :label="translations.created">
          <template slot-scope="row">
            <div v-html="formatDate(row._created)" />
          </template>
        </app-table-column>

        <template slot="footer" v-if="itemsMetadata.totalCount > params.limit">
          <app-table-pagination
              :page="listPage"
              :itemsPerPage="params.limit"
              :totalCount="itemsMetadata.totalCount"
              @pageChanged="tablePageChanged"
          />
        </template>

      </app-table>
    </app-content-body>
  </app-content>
</template>

<script>
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import { mapActions, mapState } from 'vuex'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'Labels',
  enumsMap: true
})

export default {
  name: 'label-items',
  mixins: [formatDateMixin, itemsListMixin, appTitleMixin()],
  data() {
    return {
      deletedItem: null
    }
  },
  methods: {
    ...mapActions([
      'deleteLabel'
    ]),
    fetchItems() {
      this.params.loadShowBroadcastCounters = true
      this.params.idLanguage = localStorage.ui_language_id
      this.getLabels({ params: this.params })
    },
    deleteItem(item) {
      this.deletedItem = item
    },
    refreshDeletedItem() {
      this.deletedItem = null
    },
    getIconUrl(item) {
      if (item.defaultImages.length !== 0) {
        if ('IMAGE_TYPE_SMALL' in item.defaultImages) {
          return item.defaultImages['IMAGE_TYPE_SMALL'].imageLink
        } else if ('IMAGE_TYPE_BIG' in item.defaultImages) {
          return item.defaultImages['IMAGE_TYPE_BIG'].imageLink
        } else if ('IMAGE_TYPE_SVG' in item.defaultImages) {
          return item.defaultImages['IMAGE_TYPE_SVG'].imageLink
        }
      }
      return null
    }
  },
  computed: {
    ...mapState({
      itemsMetadata: state => state.labels.labelsMetadata
    }),
    translations() {
      return {
        search: this.$gettext('Vyhledávání'),
        name: this.$gettext('Název'),
        type: this.$gettext('Typ'),
        weight: this.$gettext('Váha'),
        numberOfShows: this.$gettext('Počet pořadů'),
        numberOfBroadcasts: this.$gettext('Počet vysílání'),
        showInDashboard: this.$gettext('Zobrazit v dashboardu'),
        created: this.$gettext('Založeno'),
        numberOfSynonyms: this.$gettext('Počet synonym'),
        logo: this.$gettext('Logo')
      }
    },
    typeSelect() {
      return [
        { name: this.$gettext('Všechny typy'), value: '' },
        { name: this.$gettext('Formátový'), value: 'LABEL_TYPE_FORMAT' },
        { name: this.$gettext('Obsahový'), value: 'LABEL_TYPE_CONTENT' }
      ]
    },
    showInDashboardSelect() {
      return [
        { name: this.$gettext('Nevybráno'), value: null },
        { name: this.$gettext('Ano'), value: true },
        { name: this.$gettext('Ne'), value: false }
      ]
    },
    currentTitle() {
      return [
        this.$gettext('Štítky')
      ]
    },
    currentLanguage() {
      return this.$language.current
    }
  },
  watch: {
    currentLanguage() {
      this.fetchItems()
    },
    items() {
      this.items.forEach(e => e.numberOfSynonyms = e.synonyms.length)
    }
  }
}
</script>
